import { Link, useLocation } from 'react-router'
import { useAuth } from '@/lib/auth'
import ThemeToggle from '@/components/ThemeToggle'
import { adminMenuItems } from '@/nexus/layout/menu'
import { AnalyticsPeriodToggle } from '@/lib/analytics-period'

function crumbFor(pathname: string): string {
  const seg = pathname.split('/').filter(Boolean)[0]
  if (!seg) return 'Dashboard'
  const item = adminMenuItems.find((m) => m.url === `/${seg}`)
  return item?.label ?? seg.charAt(0).toUpperCase() + seg.slice(1)
}

export const Topbar = () => {
  const { pathname } = useLocation()
  const { user, logout } = useAuth()
  const initials = (user?.email || 'A').slice(0, 2).toUpperCase()

  return (
    <div id="layout-topbar" className="flex h-16 min-h-16 items-center justify-between gap-3 border-b border-base-300 px-4">
      <div className="flex items-center gap-2 min-w-0">
        <label
          htmlFor="layout-sidebar-toggle-trigger"
          className="btn btn-ghost btn-sm btn-square text-base-content/60 cursor-pointer"
          title="Toggle sidebar"
        >
          <span className="iconify lucide--menu size-5" />
        </label>
        <nav aria-label="Breadcrumb" className="hidden sm:flex items-center text-sm min-w-0">
          <span className="opacity-50">Admin</span>
          <span className="iconify lucide--chevron-right size-3.5 mx-1.5 opacity-40 shrink-0" />
          <span className="font-semibold truncate">{crumbFor(pathname)}</span>
        </nav>
      </div>

      <div className="flex items-center gap-1">
        <AnalyticsPeriodToggle />
        <div className="hidden md:flex items-center gap-2 h-9 px-3 rounded-lg bg-base-200 border border-base-300 text-sm text-base-content/50 w-56">
          <span className="iconify lucide--search size-4 shrink-0" />
          <span className="truncate">Search…</span>
        </div>
        <ThemeToggle />
        <div className="dropdown dropdown-end">
          <button tabIndex={0} className="btn btn-ghost btn-sm gap-2 px-2">
            <span className="grid place-items-center h-8 w-8 rounded-full bg-primary/15 text-primary text-xs font-semibold">
              {initials}
            </span>
            <span className="hidden lg:block max-w-[140px] truncate text-sm opacity-80">{user?.email}</span>
          </button>
          <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-10 mt-2 w-60 border border-base-300 p-2 shadow-lg">
            <li className="menu-title text-xs truncate">{user?.email || 'Signed in'}</li>
            <li>
              <Link to="/settings">
                <span className="iconify lucide--settings size-4" /> Settings
              </Link>
            </li>
            <li>
              <button type="button" onClick={logout} className="text-error">
                <span className="iconify lucide--log-out size-4" /> Sign out
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
